import axios from "axios";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { join, values, mapValues } from "lodash";

// const API_URL = "http://10.10.187.6/api-infobed/public/api";
const API_URL = process.env.VUE_APP_API_URL;

const instance = axios.create({
  baseURL: API_URL,
  timeout: 20000,
  params: {} // do not remove this, its added to add params later in the config
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    const token = userModule.token;
    // console.log("token", token);
    if (token) {
      config.headers.common["Authorization"] = "Bearer " + token;
      config.headers.common["Access-Control-Allow-Origin"] = "*";
    } else {
      // Use application/x-www-form-urlencoded for login
      config.headers.common["Content-Type"] =
        "application/x-www-form-urlencoded";
    }
    return config;
  },
  function (error) {
    // Do something with request error
    // alert("login err")

    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => response,
  error => {
    // let dt = error.response
    // console.log('err login ',error);
    // alert("login err")
    if (error.code === "ECONNABORTED") {
      // appModule.sendErrorNotice("Network error... Please refresh the page");
      appModule.NoticeDelayAlert("Network error... Please refresh the page");
    }
    // else if (dt.status == 422) {

    //   let message = "";

    //   message = join(
    //     values(
    //       mapValues(error.response.data.errors, function (val) {
    //         return join(val, "; ");
    //       })
    //     ),
    //     "; "
    //   );
    //   dt = { status: 0, err: "ERR 422 : " + error.response.data.message + " (" + message + ")" }
    //   // dt = { status: 0, err: "ERR 422 : " + error.response.data.message }
    //   appModule.sendErrorAlert(dt["err"]);
    // } else {
    //   dt = { data: dt, status: dt['status'], err: "ERR " + error.response.status + " : " + error.response.data.message }
    //   appModule.sendErrorAlert(dt["err"]);
    //   // alert(dt["err"]);
    // }

    return Promise.reject(error);
  }
);

export default {
  getAPI() {
    const url = `${API_URL}`;
    return url;
  },
  getData(action) {
    let url = `${API_URL}`;
    url += action;
    return instance.get(url);
  },
  getDataParam(action, data) {
    let url = `${API_URL}`;
    url += action;
    return instance.get(url, data);
  },
  postData(action, data) {
    let url = `${API_URL}`;
    url += action;
    return instance.post(url, data);
  },
  // postDataNoParam(action) {
  //   let url = `${API_URL}`;
  //   url += action;
  //   return instance.post(url);
  // },
  putData(action, data) {
    let url = `${API_URL}`;
    url += action;
    return instance.put(url, data);
  },
  deleteData(action) {
    let url = `${API_URL}`;
    url += action;
    return instance.delete(url);
  },
  login(action, data) {
    let url = `${API_URL}`;
    url += action;
    return instance.get(url, data);
  },
  apiUrl: API_URL
};
